export enum RouteNames {
    Index = 'index',
    ToProcess = 'auftraege/zu-bearbeiten',
    Processed = 'auftraege/bearbeitet',
    CreditNote = 'gutschriften/uebertragene',
    SpecialCases = 'einstellungen/sonderfaelle',
    Administrator = 'administrator/gutschriftprozessierung',
    AdminTransfer = 'administrator/uebertragen',
    AdminCreditNote = 'administrator/alle-gutschriften',
}
